module.exports = __webpack_public_path__ + "img/roles-icon.a2f9404c.svg";